import $ from '@modules/jquery-import';
import '@plugins/jquery.quickview';

$.fn.toContentToggle = async function ( opt ) {
    var staticDefaults = {
        label: `<div class="full button secondary">
            ${(opt && opt.label || 'View More')} <i class="icon-chevron-down"></i>
        </div>`,
        trigger_class: 'block',
        remove_trigger: true
    };

    var opt = $.extend( opt, staticDefaults );

    return $( this ).QuickView( opt );
};
